import classes from './ProjectManagementSystem.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import {Link} from "react-scroll";
import eRoadImg from '../../../media/projects/e-road.webp'
import Solutions from "../../../components/solutions/Solutions.tsx";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';


const ProjectManagementSystem = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
                
    const title = t('projectManagementSystem.title')
    const description = t('projectManagementSystem.text', {returnObjects: true})

    const solutionsBlocks= t('projectManagementSystem.solutionsBlocks', {returnObjects: true})
    
    const blackBlocks = t('projectManagementSystem.blackBlocks', {returnObjects: true})

    const benefitBlocks= t('projectManagementSystem.benefitBlocks', {returnObjects: true})

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('projectManagementSystem.Faq.left', {returnObjects: true}),
        right: t('projectManagementSystem.Faq.right', {returnObjects: true}),
    };

    return (
        <>
            <Helmet>
                <title>
                    Project Management Systems 📅 Boost Team Productivity | Goteco
                </title>
                <meta
                    name="description"
                    content="Manage projects efficiently! ⏳ Automate tasks, track time & collaborate with ease. Try a free demo today! "
                />
                <link rel="canonical" href="https://go-te.co/solutions/project-management-system" />
            </Helmet>
            <main>
            <Heading title={title} description={description} maxWidth={800}/>

            <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('projectManagementSystem.solutionsBlocksTitle')}</h2>
                </div>

                <div>
                    {solutionsBlocks.map(({image, title, text}) => <div className={classes.block} key={title}>
                        <img alt={title} src={require(`./media/${image}`)}/>
                        <div className={classes.content}>
                            <h5>{title}</h5>
                            <p>{text}</p>
                        </div>
                    </div>)}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['capabilities']}`} id={"nav-light"}>
                <h2>{t('projectManagementSystem.blackBlocksTitle')}</h2>
                <div className={classes.blocks}>
                    {blackBlocks.map(({text, icon}) => (<BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                </div>
            </section>

            <section className={`section--white ${classes['benefits']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('projectManagementSystem.benefitBlocksTitle')}</h2>
                </div>
                <div>
                    {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text} key={title}/>)}
                </div>
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('projectManagementSystem.Faq.title')} questions={questions}/>
            </section>

            <section className={`section--white ${classes.industries}`}>
                <Solutions/>
            </section>

            <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                <div className={classes.content}>
                    <div className={classes['text-block']}>
                        <h2>{t('projectManagementSystem.useCase')}</h2>
                        <div className={classes.text}>
                            <img src={eRoadImg} alt="Use Case"/>
                            <p>{t('projectManagementSystem.useCaseSubtitle')}</p>
                        </div>
                    </div>
                    <div className={classes.actions}>
                        <span>{t('projectManagementSystem.useCaseText')}</span>
                        <Link className={classes.link} smooth={true} to={'contact'}>{t('projectManagementSystem.useCaseButton')}</Link>
                    </div>
                </div>
                <img className={classes.img} src={eRoadImg} alt="Use Case"/>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard 
                        title={t('projectManagementSystem.formCard.title')}
                        subtitle={t('projectManagementSystem.formCard.subtitle')}
                        message={t('projectManagementSystem.formCard.message')}
                        buttonText={t('projectManagementSystem.formCard.buttonText')}
                        labels={t('projectManagementSystem.formCard.labels', {returnObjects: true})}
                        top={3} id='contact'/>
            </section>

        </main>
        </>
    );
};

export default ProjectManagementSystem;